module.exports = __webpack_public_path__ + "static/media/20_pol_0_84.54.49aeaad0.png";